export default "__VITE_ASSET__0d688e00__"